export default __webpack_public_path__ + "static/media/project3.48921354.png";